import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchNotifications = async ({ patientId, searchParams = {}, isBeforeVisit, trialId }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams(searchParams);
  params.append("is_before_visit", isBeforeVisit);
  params.append("trial_id", trialId);

  const response = await axios.get(
    `${__API_URL__}/api/appointments/get_auto_notifications/${patientId}/?${params.toString()}`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const useGetAutoNotifications = ({
  patientId,
  searchParams,
  isBeforeVisit,
  trialId,
  enabled = true,
}) => {
  return useQuery({
    queryKey: ["notifications", patientId, searchParams, isBeforeVisit, trialId],
    queryFn: () => fetchNotifications({ patientId, searchParams, isBeforeVisit, trialId }),
    enabled: enabled && Boolean(patientId) && Boolean(trialId),
    keepPreviousData: true,
  });
};

export default useGetAutoNotifications;
